
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { BranchMenuAction } from '@/types/flow-types';

export default defineComponent({
  name: 'FlowBranchMenu',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object as PropType<{ x: number; y: number }>,
      default: () => ({ x: 0, y: 0 }),
    },
    showMerge: {
      type: Boolean,
      default: true,
    },
    showClosure: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['action'],

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
